import Messages from '../constants/messages'
import {
  AUTH_PROFILE_FAILURE,
  CHANGE_PASSWORD_RECEIVE,
  CHANGE_PASSWORD_FAILURE,
  EXTERNAL_AUTH_PROFILE_FAILURE,
  LOGIN_REDIRECT_FAILURE,
  FORGOT_PASSWORD_RESET_FAILURE,
  SET_SECURITY_QUESTIONS_RECEIVE,
  SET_SECURITY_QUESTIONS_FAILURE,
  VERIFY_SECURITY_QUESTION_FAILURE } from './authProfile'
import { CLIENT_LIST_FAILURE } from './client'
import {
  DELETE_USER_DIALOG_RECEIVE,
  DELETE_USER_DIALOG_FAILURE,
  DELETE_USER_FROM_GROUP_DIALOG_RECEIVE,
  DELETE_USER_FROM_GROUP_DIALOG_FAILURE,
  REMOVE_USER_ROLE_DIALOG_RECEIVE,
  REMOVE_USER_ROLE_DIALOG_FAILURE,
  RESEND_VERIFICATION_EMAIL_DIALOG_FAILURE,
  RESEND_VERIFICATION_EMAIL_DIALOG_RECEIVE,
  RESET_PASSWORD_DIALOG_FAILURE,
  RESET_PASSWORD_DIALOG_RECEIVE,
  USER_GROUP_PATCH_DIALOG_RECEIVE,
  USER_GROUP_PATCH_DIALOG_FAILURE,
  USER_POST_DIALOG_RECEIVE,
  USER_POST_DIALOG_FAILURE } from './user'
import {
  GROUP_FILTERED_PARTNERS_FAILURE,
  GROUP_POST_DIALOG_RECEIVE,
  GROUP_POST_DIALOG_FAILURE,
  GROUP_PUT_DIALOG_RECEIVE,
  GROUP_PUT_DIALOG_FAILURE,
  GROUP_PATCH_DIALOG_RECEIVE,
  GROUP_PATCH_DIALOG_FAILURE,
  GROUP_DELETE_DIALOG_RECEIVE,
  GROUP_DELETE_DIALOG_FAILURE,
  GROUP_ROLE_DELETE_DIALOG_RECEIVE,
  GROUP_ROLE_DELETE_DIALOG_FAILURE,
  GROUP_USER_DELETE_DIALOG_RECEIVE,
  GROUP_USER_DELETE_DIALOG_FAILURE} from './group'
import { USER_PATCH_FAILURE } from './registration'
import {
  ROLES_POST_DIALOG_RECEIVE,
  ROLES_POST_DIALOG_FAILURE,
  ROLES_PUT_DIALOG_RECEIVE,
  ROLES_PUT_DIALOG_FAILURE,
  ROLES_DELETE_DIALOG_RECEIVE,
  ROLES_DELETE_DIALOG_FAILURE  } from './role'
import {
  PERMISSION_POST_DIALOG_RECEIVE,
  PERMISSION_POST_DIALOG_FAILURE,
  PERMISSION_PUT_DIALOG_RECEIVE,
  PERMISSION_PUT_DIALOG_FAILURE,
  PERMISSION_DELETE_DIALOG_RECEIVE,
  PERMISSION_DELETE_DIALOG_FAILURE } from './permission'
import {
  STOCK_SECURITY_QUESTIONS_FAILURE
} from './securityQuestionsFormDialog'
import { DATA_LOAD_FAILURE } from './loading'

export const CLOSE_NOTIFICATION = 'notifications/CLOSE_NOTIFICATION'

const initialState = {
  showNotification: false,
  message: ''
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_PASSWORD_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['pageMessages']['PASSWORD_CHANGED_MSG']
      }
    case CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['userErrors']['CHANGE_PASSWORD']
      }
    case CLIENT_LIST_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA23']
      }
    case CLOSE_NOTIFICATION:
      return {
        ...state,
        showNotification: false,
        message: ''
      }
    case DELETE_USER_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['USER_DELETED_MSG']
      }
    case DELETE_USER_FROM_GROUP_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['GROUP_USER_REMOVED_MSG']
      }
    case DELETE_USER_FROM_GROUP_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA2']
      }
    case REMOVE_USER_ROLE_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['USERS_ROLE_UPDATED_MSG']
      }
    case REMOVE_USER_ROLE_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA3']
      }
    case AUTH_PROFILE_FAILURE:
    case DELETE_USER_DIALOG_FAILURE:
    case EXTERNAL_AUTH_PROFILE_FAILURE:
    case LOGIN_REDIRECT_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA1']
      }
    case PERMISSION_POST_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA4']
      }
    case PERMISSION_POST_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['PERMISSON_CREATED_MSG']
      }
    case PERMISSION_PUT_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA5']
      }
    case PERMISSION_PUT_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['PERMISSON_UPDATED_MSG']
      }
    case PERMISSION_DELETE_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA6']
      }
    case PERMISSION_DELETE_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['PERMISSON_DELETED_MSG']
      }
    case FORGOT_PASSWORD_RESET_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['userErrors']['FORGOT_PASSWORD']
      }
    case ROLES_POST_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['ROLE_CREATED_MSG']
      }
    case ROLES_POST_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA7']
      }
    case ROLES_PUT_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['ROLE_UPDATED_MSG']
      }
    case ROLES_PUT_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA8']
      }
    case ROLES_DELETE_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['ROLE_DELETED_MSG']
      }
    case ROLES_DELETE_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA10']
      }
    case SET_SECURITY_QUESTIONS_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['SECURITY_QUESTION_SET_MSG']
      }
    case SET_SECURITY_QUESTIONS_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA20']
      }
    case STOCK_SECURITY_QUESTIONS_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA21']
      }
    case VERIFY_SECURITY_QUESTION_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA22']
      }
    case USER_GROUP_PATCH_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['USERS_GROUP_UPDATED_MSG']
      }
    case USER_GROUP_PATCH_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA11']
      }
    case GROUP_FILTERED_PARTNERS_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA12']
      }
    case GROUP_POST_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['GROUP_CREATED_MSG']
      }
    case GROUP_POST_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA13']
      }
    case GROUP_ROLE_DELETE_DIALOG_RECEIVE:
    case GROUP_PATCH_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['GROUP_UPDATED_MSG']
      }
    case GROUP_ROLE_DELETE_DIALOG_FAILURE:
    case GROUP_PATCH_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA9']
      }
    case GROUP_PUT_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['GROUP_UPDATED_MSG']
      }
    case GROUP_PUT_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA9']
      }
    case GROUP_DELETE_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['GROUP_DELETED_MSG']
      }
    case GROUP_DELETE_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA14']
      }
    case GROUP_USER_DELETE_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['GROUP_USER_REMOVED_MSG']
      }
    case GROUP_USER_DELETE_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA2']
      }
    case DATA_LOAD_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA15']
      }
    case USER_POST_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['USER_CREATED_MSG']
      }
    case USER_POST_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA1']
      }
    case USER_PATCH_FAILURE:
      let errorMessages = action.payload && action.payload.response && action.payload.response.data && action.payload.response.data.items
      let message = Messages['systemErrors']['PA16']

      if(errorMessages.includes('Api validation failed: password')) {
        message = Messages['systemErrors']['PA17']
      }

      return {
        ...state,
        showNotification: true,
        message: message
      }
    case RESET_PASSWORD_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA18']
      }
    case RESEND_VERIFICATION_EMAIL_DIALOG_FAILURE:
      return {
        ...state,
        showNotification: true,
        message: Messages['systemErrors']['PA19']
      }
    case RESEND_VERIFICATION_EMAIL_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['VERIFICATION_EMAIL_SENT_MSG']
      }
    case RESET_PASSWORD_DIALOG_RECEIVE:
      return {
        ...state,
        showNotification: true,
        message: Messages['notificationMessages']['PASSWORD_RESET_EMAIL_SENT_MSG']
      }
    default:
      return state
  }
}

export const closeNotification = () => ({ type: CLOSE_NOTIFICATION })

export default reducer
